import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  useEffect(() => {
    if (activeModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [activeModal]);
  return <>
      <footer className="bg-brand-dark text-gray-400 py-10 px-4" data-id="element-11">
        <div className="max-w-3xl mx-auto text-center" data-id="element-12">
          <p className="text-sm mb-4" data-id="element-13">
            Este producto no sustituye el consejo médico profesional. Consulte a
            su médico antes de comenzar cualquier programa.
          </p>
          <div className="flex items-center justify-center gap-4 text-sm mb-4" data-id="element-14">
            <button onClick={() => setActiveModal('privacy')} className="underline underline-offset-2 hover:text-white transition-colors" data-id="element-15">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-16">|</span>
            <button onClick={() => setActiveModal('terms')} className="underline underline-offset-2 hover:text-white transition-colors" data-id="element-17">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-xs text-gray-500" data-id="element-18">
            &copy; {new Date().getFullYear()} Protocolo 48H. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fadeIn" onClick={() => setActiveModal(null)} data-id="element-19">
          <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden animate-slideUp" onClick={e => e.stopPropagation()} data-id="element-20">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 sticky top-0 bg-white z-10" data-id="element-21">
              <h2 className="font-serif text-2xl text-brand-dark" data-id="element-22">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-gray-100 transition-colors text-gray-500 hover:text-brand-dark" data-id="element-23">
                <X className="w-5 h-5" data-id="element-24" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="px-6 py-6 overflow-y-auto max-h-[calc(85vh-4rem)] text-brand-dark/80 text-base leading-relaxed space-y-4" data-id="element-25">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-26" /> : <TermsContent data-id="element-27" />}
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-sm text-gray-500" data-id="element-28">Última actualización: marzo 2026</p>

      <h3 className="font-bold text-lg text-brand-dark mt-4" data-id="element-29">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-30">
        Al adquirir el Protocolo Anti-Inflamación 48H, recopilamos únicamente la
        información necesaria para procesar tu compra: nombre, dirección de
        correo electrónico y datos de pago. No almacenamos datos de tarjetas de
        crédito en nuestros servidores; estos son procesados de forma segura por
        nuestro proveedor de pagos certificado.
      </p>

      <h3 className="font-bold text-lg text-brand-dark mt-4" data-id="element-31">
        2. Uso de la Información
      </h3>
      <p data-id="element-32">
        Utilizamos tu información exclusivamente para: entregar el producto
        digital adquirido, enviar confirmaciones de compra, proporcionar soporte
        al cliente relacionado con tu compra y, solo si lo autorizas, enviarte
        actualizaciones sobre el protocolo.
      </p>

      <h3 className="font-bold text-lg text-brand-dark mt-4" data-id="element-33">
        3. Protección de Datos
      </h3>
      <p data-id="element-34">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción. Toda la comunicación se realiza
        mediante conexiones cifradas (SSL/TLS).
      </p>

      <h3 className="font-bold text-lg text-brand-dark mt-4" data-id="element-35">
        4. Compartir Información
      </h3>
      <p data-id="element-36">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros. La única excepción son los proveedores de servicios que nos
        asisten en la operación del sitio web y el procesamiento de pagos,
        quienes están obligados a mantener la confidencialidad de dicha
        información.
      </p>

      <h3 className="font-bold text-lg text-brand-dark mt-4" data-id="element-37">5. Cookies</h3>
      <p data-id="element-38">
        Nuestro sitio puede utilizar cookies para mejorar la experiencia del
        usuario. Puedes configurar tu navegador para rechazar cookies, aunque
        esto podría afectar algunas funcionalidades del sitio.
      </p>

      <h3 className="font-bold text-lg text-brand-dark mt-4" data-id="element-39">
        6. Tus Derechos
      </h3>
      <p data-id="element-40">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. Para ejercer estos derechos, puedes contactarnos a
        través de los canales indicados en tu confirmación de compra.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-sm text-gray-500" data-id="element-41">Última actualización: marzo 2026</p>

      <h3 className="font-bold text-lg text-brand-dark mt-4" data-id="element-42">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-43">
        Al realizar la compra del Protocolo Anti-Inflamación 48H, aceptas estos
        términos y condiciones en su totalidad. Si no estás de acuerdo con
        alguna parte de estos términos, te recomendamos no proceder con la
        compra.
      </p>

      <h3 className="font-bold text-lg text-brand-dark mt-4" data-id="element-44">
        2. Naturaleza del Producto
      </h3>
      <p data-id="element-45">
        El Protocolo Anti-Inflamación 48H es un producto digital de carácter
        informativo y educativo. No constituye consejo médico, diagnóstico ni
        tratamiento. Siempre consulta a un profesional de la salud calificado
        antes de realizar cambios en tu alimentación o estilo de vida,
        especialmente si tienes condiciones médicas preexistentes.
      </p>

      <h3 className="font-bold text-lg text-brand-dark mt-4" data-id="element-46">
        3. Entrega del Producto
      </h3>
      <p data-id="element-47">
        Tras completar el pago, recibirás acceso inmediato al contenido digital
        en formato PDF a través del correo electrónico proporcionado durante la
        compra. Es tu responsabilidad asegurarte de que la dirección de correo
        sea correcta.
      </p>

      <h3 className="font-bold text-lg text-brand-dark mt-4" data-id="element-48">
        4. Política de Reembolso
      </h3>
      <p data-id="element-49">
        Ofrecemos una garantía de satisfacción de 7 días. Si no estás satisfecho
        con el producto, puedes solicitar un reembolso completo dentro de los 7
        días posteriores a la compra, sin preguntas.
      </p>

      <h3 className="font-bold text-lg text-brand-dark mt-4" data-id="element-50">
        5. Propiedad Intelectual
      </h3>
      <p data-id="element-51">
        Todo el contenido del Protocolo Anti-Inflamación 48H está protegido por
        derechos de autor. La compra te otorga una licencia personal e
        intransferible para uso individual. Queda prohibida la reproducción,
        distribución o reventa del material sin autorización expresa por
        escrito.
      </p>

      <h3 className="font-bold text-lg text-brand-dark mt-4" data-id="element-52">
        6. Limitación de Responsabilidad
      </h3>
      <p data-id="element-53">
        Los resultados pueden variar de persona a persona. No garantizamos
        resultados específicos. El uso del protocolo es bajo tu propia
        responsabilidad. No nos hacemos responsables de efectos adversos
        derivados de la aplicación incorrecta del protocolo o de ignorar la
        recomendación de consultar a un profesional médico.
      </p>

      <h3 className="font-bold text-lg text-brand-dark mt-4" data-id="element-54">
        7. Modificaciones
      </h3>
      <p data-id="element-55">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones serán efectivas desde su publicación en esta
        página. El uso continuado del producto tras cualquier modificación
        constituye la aceptación de los nuevos términos.
      </p>
    </>;
}